import React, { useEffect, useState } from "react";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { RiFullscreenFill } from "react-icons/ri";
import { IoDownloadOutline } from "react-icons/io5";
import {
  Box,
  Header,
  HeaderImage,
  Content,
  SlideWrapper,
  TitleBox,
  Title,
  SliderImage,
  SlidePanel,
  Slider,
  SlideText,
  VideoWrapper,
  Video,
  Chat,
  ButtonWrapper,
} from "./styles";
import { getEventStyles, getWebinars } from "../api/";
import { StylesProps, WebinarsProps } from "../types";
import { useParams, useHistory } from "react-router-dom";
import { Button } from "../../../components/videoConference/Button";
import { getContrastColor } from "../../../utils/isDarkColor";
import { EMBED_URL } from "../../../settings";
import { t } from "i18next";

interface RouteParams {
  kind: string;
}

export default function Watch() {
  const [currentSlide, setCurrentSlide] = useState(1);
  const [totalSlides, setTotalSlides] = useState(24);
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [slideUrl, setSlideUrl] = useState("");
  const { kind } = useParams<RouteParams>();
  const [webinars, setWebinars] = useState<WebinarsProps | null>(null)

  const [styles, setStyles] = useState<StylesProps | null>(null)
  const [userData, setUserData] = useState<any>(null)
  const [initialSlideUrl, setInitialSlideUrl] = useState("")
  const history = useHistory()

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (document.fullscreenElement) {
        if (event.key === "ArrowRight") {
          nextSlide();
        } else if (event.key === "ArrowLeft") {
          previousSlide();
        }
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [currentSlide, totalSlides]);

  useEffect(() => {
    getStyles()
    getGroup()
  }, [kind])

  useEffect(() => {
    if (!webinars || !kind) return
    if (localStorage.getItem(`@NDI-WEBINAR-${webinars.name}`)) {
      setUserData(JSON.parse(localStorage.getItem(`@NDI-WEBINAR-${webinars.name}`) || '{}'))
    } else {
      history.push(`/${kind}/formulario`)
    }
  }, [webinars, kind])

  useEffect(() => {
    if (userData) {
      getInitialSlideUrl()
    }
  }, [userData])

  async function getGroup() {
    if (kind) {
      const response = await getWebinars({
        kind: kind
      })

      if (response.data.length === 0) return
      setWebinars(response.data.groups[0])
    }
  }

  async function getStyles() {
    if (kind) {
      const response = await getEventStyles({
        kind: kind
      })
      setStyles(response.data)
    }
  }

  function nextSlide() {
    const nextSlide = (currentSlide % totalSlides) + 1;
    setCurrentSlide(nextSlide);
    setSlideUrl(`${initialSlideUrl}_${nextSlide - 1}.jpeg`);
  }

  function previousSlide() {
    const previousSlide = currentSlide - 1 === 0 ? totalSlides : currentSlide - 1;
    setCurrentSlide(previousSlide);
    setSlideUrl(`${initialSlideUrl}_${previousSlide - 1}.jpeg`);
  }

  function toggleFullScreen() {
    var slideElement = document.getElementById("slider-image");

    if (slideElement) {
      if (!document.fullscreenElement) {
        if (slideElement.requestFullscreen) {
          slideElement.requestFullscreen();
          setIsFullScreen(true);
        }
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen();
          setIsFullScreen(false);
        }
      }
    }
  }

  function getButtonText() {

    const selectedTalk = userData?.talk
    const selectedWebinar = webinars?.talks.find(webinar => webinar.playback_stream_name !== selectedTalk)
    return selectedWebinar?.title || ""
  }

  function getInitialSlideUrl() {
    const selectedTalk = userData?.talk
    const selectedWebinar = webinars?.talks.find(webinar => webinar.playback_stream_name === selectedTalk)
    if (!selectedWebinar?.slides) return
    const formattedSlide = selectedWebinar?.slides.replace('.pdf', '')
    setInitialSlideUrl(formattedSlide)
    setSlideUrl(`${formattedSlide}_0.jpeg`)
    setTotalSlides(selectedWebinar?.num_slides || 24)
  }

  function onChangeTalk() {
    const selectedTalk = userData?.talk
    const nextWebinar = webinars?.talks.find(webinar => webinar.playback_stream_name !== selectedTalk)

    if (nextWebinar?.slides) {
      const formattedSlide = nextWebinar?.slides.replace('.pdf', '')
      setInitialSlideUrl(formattedSlide)
      setSlideUrl(`${formattedSlide}_0.jpeg`)
      setTotalSlides(nextWebinar?.num_slides || 24)
    } else {
      setInitialSlideUrl("")
      setSlideUrl(``)
    }
    setCurrentSlide(1)
    const nextTalk = nextWebinar?.playback_stream_name
    setUserData({ ...userData, talk: nextTalk, chatEnabled: nextWebinar?.chat_enabled })
    localStorage.setItem(`@NDI-WEBINAR-${webinars?.name}`,
      JSON.stringify({ ...userData, talk: nextTalk, chatEnabled: nextWebinar?.chat_enabled }))
  }

  function onChangeMultipleTalks(talk: string) {
    const nextWebinar = webinars?.talks.find(webinar => webinar.playback_stream_name === talk)
    if (nextWebinar?.slides) {
      const formattedSlide = nextWebinar?.slides.replace('.pdf', '')
      setInitialSlideUrl(formattedSlide)
      setSlideUrl(`${formattedSlide}_0.jpeg`)
      setTotalSlides(nextWebinar?.num_slides || 24)
    } else {
      setInitialSlideUrl("")
      setSlideUrl(``)
    }
    setCurrentSlide(1)
    setUserData({ ...userData, talk: talk, chatEnabled: nextWebinar?.chat_enabled })
    localStorage.setItem(`@NDI-WEBINAR-${webinars?.name}`,
      JSON.stringify({ ...userData, talk: talk, chatEnabled: nextWebinar?.chat_enabled }))

  }
  console.log(webinars?.talks.length)
  return (
    <Box>
      <Header backgroundColor={styles?.header?.backgroundColor} >
        <HeaderImage src={styles?.images?.logo} />
      </Header>

      <Content backgroundImage={styles?.images?.banners[0] && styles?.images?.banners[0]?.url}>
        {initialSlideUrl && (
          <SlideWrapper>
            <TitleBox descriptionBackground={styles?.body?.watch.descriptionBackground}>
              <Title style={{ color: getContrastColor(styles?.body?.watch.descriptionBackground || "") }}>{t("watch.presentation")}</Title>
            </TitleBox>
            <div id="slider-image">
              <SliderImage
                isFullScreen={isFullScreen}
                src={slideUrl}
                alt="Slider Image"
              />

              <SlidePanel>
                <IoDownloadOutline
                  size="23px"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    window.open(`${initialSlideUrl}.pdf`, "_blank");
                  }}
                />

                <Slider>
                  <IoIosArrowBack
                    style={{ cursor: "pointer" }}
                    onClick={previousSlide}
                  />
                  <SlideText>
                    Slides {currentSlide}/{totalSlides}
                  </SlideText>
                  <IoIosArrowForward
                    style={{ cursor: "pointer" }}
                    onClick={nextSlide}
                  />
                </Slider>

                <RiFullscreenFill
                  size="23px"
                  style={{ cursor: "pointer" }}
                  onClick={toggleFullScreen}
                />
              </SlidePanel>
            </div>
            {webinars?.talks.length !== 1 && (
              <ButtonWrapper>
                {webinars?.talks && webinars?.talks.length > 2 ? (
                  <>
                    {webinars?.talks.filter(webinar => webinar.playback_stream_name !== userData?.talk).map((webinar) => (
                      <Button onClick={() => onChangeMultipleTalks(webinar.playback_stream_name)} title={webinar.title} colorfont={getContrastColor(styles?.body?.form.bannerBackground || "")} style={{
                        backgroundColor: styles?.body?.form.bannerBackground,
                        marginTop: "20px",
                      }} />
                    ))}
                  </>
                ) : (
                  <Button onClick={onChangeTalk} title={getButtonText()} colorfont={getContrastColor(styles?.body?.form.bannerBackground || "")} style={{
                    backgroundColor: styles?.body?.form.bannerBackground,
                    marginTop: "20px",
                  }} />
                )}
              </ButtonWrapper>
            )}
          </SlideWrapper>
        )}

        <VideoWrapper haveSlide={!!initialSlideUrl}>
          <div >
            <TitleBox descriptionBackground={styles?.body?.watch.descriptionBackground}>
              <Title style={{ color: getContrastColor(styles?.body?.watch.descriptionBackground || "") }}>{t("watch.earning")}</Title>
            </TitleBox>
            <Video haveSlide={!!initialSlideUrl}>
              <iframe
                id="videoIframe"
                className="frame-video"
                src={`${EMBED_URL}player-embed/${userData?.talk}/?email=${userData?.email}`}
                style={{ borderRadius: "0 0 8px 8px" }}
                width="540"
                height="250"
                allowFullScreen
                frameBorder="0"
              ></iframe>
            </Video>
            <ButtonWrapper>
              {!initialSlideUrl && webinars?.talks.length !== 1 && (
                <>
                  {webinars?.talks && webinars?.talks.length > 2 ? (
                    <>
                      {webinars?.talks.filter(webinar => webinar.playback_stream_name !== userData?.talk).map((webinar) => (
                        <Button onClick={() => onChangeMultipleTalks(webinar.playback_stream_name)} title={webinar.title} colorfont={getContrastColor(styles?.body?.form.bannerBackground || "")} style={{
                          backgroundColor: styles?.body?.form.bannerBackground,
                          marginTop: "20px",
                        }} />
                      ))}
                    </>
                  ) : (
                    <Button onClick={onChangeTalk} title={getButtonText()} colorfont={getContrastColor(styles?.body?.form.bannerBackground || "")} style={{
                      backgroundColor: styles?.body?.form.bannerBackground,
                      marginTop: "20px",
                    }} />
                  )}
                </>
              )}
            </ButtonWrapper>
          </div>
          {webinars?.talks.find(webinar => webinar.playback_stream_name === userData?.talk)?.chat_enabled &&
            (
              <Chat haveSlide={!!initialSlideUrl}>
                <iframe
                  id="chatIframe"
                  className="frame-chat"
                  src={`${EMBED_URL}chat-embed/${userData?.talk}/?auto_join=true&username=${userData?.name} | ${userData?.company}&header_title=Perguntas`}
                  width="540"
                  height="360"
                  allowFullScreen
                  frameBorder="0"
                ></iframe>
              </Chat>
            )
          }
        </VideoWrapper>
      </Content>
    </Box>
  );
}
